import React from 'react';
import PropTypes from 'prop-types';

import {Box, Stack, Typography} from 'views/components';

import {Translate} from '../Translate';

import responseViews from './response_views';

const CommandResponseView = (props) => {
  const {response} = props;

  if (!response) {
    return null;
  }

  const ResponseView = responseViews[response.outputType];

  return (
    <Stack
      sx={{
        px: '12px',
        gap: '8px',
      }}
    >
      <Typography
        sx={{
          px: '6px',
          fontSize: '12px',
          fontWeight: 600,
          lineHeight: '100%',
          color: '#A8A49E',
          textTransform: 'uppercase',
        }}
      >
        <Translate expression='skills.SkillsModule.Response.QueuedForApproval' />
      </Typography>
      <Box>
        {
          ResponseView && (
            <ResponseView {...props} />)
        }
      </Box>
    </Stack>
  );
};

CommandResponseView.propTypes = {
  communicationTarget: PropTypes.object,
  isRegenerating: PropTypes.bool,
  onDiscard: PropTypes.func,
  onRegenerate: PropTypes.func,
  requester: PropTypes.object.isRequired,
  response: PropTypes.shape({
    content: PropTypes.string,
    message: PropTypes.string,
    outputType: PropTypes.string.isRequired,
    subject: PropTypes.string,
    text: PropTypes.string,
  }),
};

export default React.memo(CommandResponseView);
